/**
 * Logout Component
 */

import tr from '../../../../locales';
import * as notifications from '../../../../redux/actions/notifications';
import { toggleHeaderVisibility } from '../../../../redux/actions/ui';
import { requestUserLogOut } from '../../../../redux/actions/user';
import { LogoutFormFragment } from '../../../../relay/logout';
import './styles.scss';

import { RouteMatch } from 'found';
import * as React from 'react';
import { connect } from 'react-redux';
import { createFragmentContainer } from 'react-relay';

import Page from '../../../../containers/Page';
import Heading from '../../../atoms/text/Heading';
import { DiscoverPagePath } from '../../browse/Discover';

// Page Path
export const LogoutPagePath = '/logout';

interface IOwnDispatchProps {
  pushNotification: (notification: INotificationProps) => void;
  requestLogOut: (payload: IRequestUserLogOutActionPayload) => void;
  toggleHeader: (toggle: boolean) => void;
}

type IOwnPickedDispatchProps = Pick<IOwnDispatchProps, 'pushNotification' | 'toggleHeader'>;

interface IOwnMergedProps {
  requestLogOut: () => Promise<any>;
}

interface IOwnProps extends RouteMatch {
  viewer: GQL.IViewer;
}

type LogoutProps = IOwnProps & IOwnPickedDispatchProps & IOwnMergedProps;

class Logout extends React.Component<LogoutProps, {}> {
  private olark;

  componentDidMount() {
    this.props.toggleHeader(false);
    this.logUserOut();

    // tslint:disable-next-line:no-string-literal
    this.olark = window['olark'];
    this.olark('api.box.hide');
  }

  componentWillUnmount() {
    this.props.toggleHeader(true);
    this.olark('api.box.show');
    this.olark = null;
  }

  async logUserOut() {
    const {
      pushNotification,
      requestLogOut,
      router,
    } = this.props;

    try {
      await requestLogOut();
      pushNotification({
        message: tr.logout.successMessage,
        state: 'success',
      });
      setTimeout(() => router.replace(DiscoverPagePath), 250);
    } catch (error) {
      pushNotification({
        autoDismiss: false,
        message: 'We were unable to log you out. Please check your Internet connection and try again later.',
        state: 'error',
      });
      console.error(error);
      setTimeout(() => router.go(-1), 250);
    }
  }

  render() {
    return (
      <Page id="logout">
        <Heading is="h2" textColor="bw6">Logging you out...</Heading>
      </Page>
    );
  }
}

const ConnectedLogout = connect<{}, IOwnDispatchProps, IOwnProps, LogoutProps, IStoreState>(
  null,
  (dispatch) => ({
    pushNotification(notification) {
      dispatch(notifications.pushNotification(notification));
    },
    requestLogOut: (payload) => {
      dispatch(requestUserLogOut(payload));
    },
    toggleHeader: (toggle) => {
      dispatch(toggleHeaderVisibility(toggle));
    },
  }),
  (_, dispatchProps, ownProps) => ({
    ...dispatchProps,
    ...ownProps,
    requestLogOut: () =>
      new Promise((resolve, reject) => {
        dispatchProps.requestLogOut({
          promise: { resolve, reject },
          viewerId: ownProps.viewer.id,
        });
      }),
  }),
)(Logout);

const RelayLogout = createFragmentContainer(
  ConnectedLogout,
  LogoutFormFragment,
);

export default RelayLogout;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/account/Logout/index.tsx